import { render } from "./ReservationReportIndex.vue?vue&type=template&id=dd15dea6"
import script from "./ReservationReportIndex.vue?vue&type=script&lang=js"
export * from "./ReservationReportIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__